export const MediaBuyingDetailsData = [
  {
    icon:"ri:ai-generate",
    title:'LEAD GENERATION',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"tabler:hand-finger" ,
    title:'E-COMMERCE',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"iconoir:message-text",
    title:'SEM',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"system-uicons:clipboard-notes" ,
    title:'EMAIL MARKETING',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"lucide:search-slash"  ,
    title:'PPC',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },
  {
    icon:"heroicons:computer-desktop-20-solid",
    title:'GDM',
    disc:"Lorem ipsum dolor sit amet consectetur. Orci orci aenean phasellus duis at. Hendrerit tellus vulputate at tellus vitae"
  },

]